<template>
  <div id="posts-masonry">
    <div class="container-fluid">
      <h1>{{ currentList.title }}</h1>
      <!-- Feed of posts -->
      <div v-if="posts.length" class="card-columns">
        <div class="card post-card" v-for="post in posts" @click="openPostModal(post)">
          <img class="card-img-top" v-for="media in post.media.slice(0, 1)" :src="media.small" width="100%" alt="Card image cap" />
          <div class="card-body">
            <h5 class="card-title">{{ post.title }}</h5>
            <p class="card-text">{{ post.body | trimLength }}</p>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.card-columns -->
      <div v-else>
        <div class="card">
          <div class="card-body">
            <p class="card-text">There are currently no posts</p>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div>
    </div><!-- /.container-fluid -->
  </div><!-- /#posts-masonry -->
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  const fb = require('../firebaseConfig.js')

  export default {
    data() {
      return {
      }
    },
    computed: {
      ...mapState(['userProfile', 'currentUser', 'posts', 'currentList'])
    },
    created: function() {
      let self = this
      if (self.$route.name == 'Visualization' && self.$route.params.mode == 'user') {
        let userData
        fb.usersCollection.doc(self.$route.params.id).get().then(res => {
          userData = res.data()
          self.$store.dispatch('setCurrentList', {title: userData.company})
          console.log(userData)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    methods: {
      openPostModal(post) {
        console.log(this.$route.name)
        if (this.$route.name == 'Dashboard' || this.$route.name == 'DashboardMode' || this.$route.name == 'List') {
          this.$emit('openPostModal', post)
        } else {
          this.$router.push('/post/' + post.id)
        }
      }
    },
    filters: {
      formatDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        return moment(date).fromNow()
      },
      trimLength(val) {
        if (val.length < 200) {
          let regex = /(<([^>]+)>)/ig;
          let cleanVal = val.replace(regex, " ");
          return cleanVal
         }
        let regex = /(<([^>]+)>)/ig;
        let cleanVal = val.replace(regex, " ");
        return `${cleanVal.substring(0, 200)}...`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PostsMasonry.vue